import axios from 'axios';

const IS_DEV = process.env.REACT_APP_IS_DEV;
console.log("DEV:", IS_DEV);
export const API_URL = IS_DEV ? "http://localhost:8080" : "https://api.truesearcher.com";
console.log("API_URL:", API_URL);

export async function getRequest(path: string, params: any): Promise<any> {
    try {
        let address = API_URL + path;
        let res = await axios.get(address, { params });
        return res.data
    } catch (err) {
        // TODO figure out error handling 
        console.log(err);
    }
}

export async function postRequest(path: string, body: any, params: any): Promise<any> {
    try {
        let address = API_URL + path;
        let res = await axios.post(address, body, { params });
        return res.data;
    } catch (err) {
        // TODO figure out error handling
        console.log(err);
    }
}
